import { useAnalytics } from "@hooks/useAnalytics";
import { useRichText } from "@hooks/useRichText";
import { ComponentProps, FromSanityGraphQL } from "@ts/components";
import { type Content, type SectionRichtext } from "@ts/sanity";
import React, { useCallback, type FC } from "react";

type RichTextInputProps = ComponentProps & FromSanityGraphQL<SectionRichtext>;

export type RichTextOutputProps = RichTextInputProps & {
  content: Content;
  handlePromoClick: () => void;
};

export const withRichtext =
  (Component: FC<RichTextOutputProps>) =>
  ({
    name = "Richtext",
    analytics,
    content,
    ...props
  }: RichTextOutputProps) => {
    const { trackPromoClick } = useAnalytics();
    const { parseContent } = useRichText();
    const normalisedContent = parseContent(content);

    const handlePromoClick = useCallback(() => {
      if (!analytics) {
        return;
      }
      trackPromoClick(analytics);
    }, [analytics, trackPromoClick]);

    Component.displayName = name;
    return (
      <Component
        {...props}
        content={normalisedContent}
        handlePromoClick={handlePromoClick}
      />
    );
  };
